/**
 * Returns a display name for the SCM provider based on the scmId.
 */
export function getScmDisplayName(scmId: string): string {
    switch (scmId.toLowerCase()) {
        case "github":
            return "GitHub";
        case "gitlab":
            return "GitLab";
        case "bitbucket":
            return "Bitbucket";
        case "azuredevops":
            return "Azure DevOps";
        default:
            return "repository";
    }
}
